import { mapGetters } from "vuex";
import pageheader from "../pageheader";
import utils from "../../utils/util";
import moment from "moment";
import config from "../../../secrets/config";

export default {
  name: "telematics",
  components: { pageheader },
  props: ["respData"],

  data() {
    return {
      input: {},
      responseData: {},
      configdata: config.ENABLE_ACCESS_CODE,

      deviceType: "",
      serialNumber: "",
      productionDate: "",
      telematics: {
        accessControlMode: "",
        accessControlType: "",
        firmwareVersion: "",
        latestCanData: false,
        latestFirmware: false,
        latestInsightsData: "",
        latestPosition: "",
        canSupport: false,
        canProfile: "",
        powerSupply: "",
        batteryLevel: "",
        batteryPercentage: "",
        gpsSatellites: "",
        deviceType: "",
        serialNumber: "",
        productionDate: "",
        gpsSatellitesPercentage: "",
        batteryLevelPercentage: "",
        powerSupplyPercentage: "",
      },
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        // var dateFormat = moment.utc(value).format();
        // var local_date= moment.utc(dateFormat).local().format('MMMM d, YYYY, HH:mm A');
        var local_date = moment(value).format("MM/DD/YYYY, HH:mm A");
        return local_date;
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("telematics", this.roles);
    this.responseData = this.respData;
    this.telematics = this.responseData.telematics;
    this.deviceType = this.responseData.deviceModel;
    this.serialNumber = this.responseData.serialNumber;
    this.productionDate = this.responseData.specification.productionDate;
    this.responseData.externalPowerPercentage =
      (this.responseData.externalPower / 14) * 100;
    // this.telematics.gpsSatellites = this.telematics.gpsSatellites*10;
    this.telematics.gpsSatellitesPercentage =
      (this.telematics.gpsSatellites / 6) * 100;
    this.telematics.batteryLevelPercentage = this.hasReading(
      this.telematics.batteryLevel
    )
      ? (this.telematics.batteryLevel / 4) * 100
      : null;
    this.telematics.powerSupplyPercentage =
      (this.telematics.powerSupply / 25) * 100;
  },
  methods: {
    // BE-1130: the API sends null when Trackunit has no battery reading. That must read
    // blank, not 0; a real 0 is a reading.
    hasReading(value) {
      return value !== null && value !== undefined && value !== "";
    },
  },
};
